export default {
  viewBox: "0 0 16 16",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.267 2.003c.77-1.335 2.696-1.335 3.465 0l4.903 8.498c.77 1.333-.193 3-1.732 3H3.097c-1.54 0-2.502-1.667-1.732-3zM8 5.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 1 1-1 0V6a.5.5 0 0 1 .5-.5M8 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1\" clip-rule=\"evenodd\"/>"
};